import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import ManagePackagingMaterialActionModalContainer from './ManagePackagingMaterialActionModalContainer';
import {setPhproductformManagePackagingMaterialModal} from '../../../../store/slice/PharmaSlice';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '85%', xs: '95%' },
  height: { lg: '85%', xs: '95%' },
  borderRadius: 3,
  //overflow:'scroll',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function ManagePackagingMaterialActionModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {managePackagingMaterialModalOpen, phproductformObj} = useSelector((state)=>state.pharmaslice.phproductformDashboard);

  useEffect(()=>{
  },[managePackagingMaterialModalOpen])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setPhproductformManagePackagingMaterialModal(false));
  }
  return (
    <Modal
       open={managePackagingMaterialModalOpen===undefined?false:managePackagingMaterialModalOpen}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center"
        sx={{borderBottom:'1px solid #e0e0e0'}}>
          <Grid item>
            <Typography variant="h5"  >
              Manage Packaging Material @ {phproductformObj.title}
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item paddingTop={1}> 
            < ManagePackagingMaterialActionModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}